import { NavbarClasses, NAVIGATION } from './constants';
import classNames from 'classnames';
import { AnimatePresence, m } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ReactNode, useMemo } from 'react';
import { ThemeBackground, ThemePrimary, ThemeText } from '../../context/theme/ThemeConstantsUpdated';
import { useAuth } from '../../context/auth/useAuth';
import { getUserHomePageUrl } from '../user/user.constants';

const { borderBackground, mainBackground } = ThemeBackground;
const { primaryTextHover } = ThemePrimary;
const { mainText } = ThemeText;

export const MobileNavbar = (props: Props) => {
  const { isOpen, toggle, navbarSizeClasses, renderLightingToggle } = props;
  const { currentUser } = useAuth();
  const userPageUrl = currentUser ? getUserHomePageUrl(currentUser) : undefined;
  const contentTopOffset = useMemo(
    () => Number(navbarSizeClasses.contentTopPadding.match(/\d+/)?.[0] || '0'),
    [navbarSizeClasses.contentTopPadding]
  );

  return (
    <AnimatePresence key="mobile_navbar">
      {isOpen && (
        <m.div
          initial={{ x: '-100%' }}
          animate={{ x: '0%' }}
          exit={{ x: '-100%' }}
          transition={{ duration: 0.5, ease: 'easeInOut' }}
          className={classNames('fixed inset-0 z-10')}
          onClick={() => toggle()}
        >
          <m.div
            onClick={(e) => e.stopPropagation()}
            animate={{ top: contentTopOffset }}
            transition={{ duration: 0.25, ease: 'easeInOut' }}
            className={classNames(
              borderBackground,
              mainBackground,
              'fixed inset-y-0 left-0 z-20 w-60 overflow-y-auto border-r border-t px-6 py-6'
            )}
          >
            <div className="flex h-full flex-col">
              <div className="grow space-y-2">
                {NAVIGATION(userPageUrl).map((item) => (
                  <Link
                    key={item.name}
                    to={item.to}
                    className={classNames(
                      mainText,
                      primaryTextHover,
                      '-mx-3 block rounded-lg px-3 py-2 text-base font-semibold leading-7'
                    )}
                  >
                    {item.name}
                  </Link>
                ))}
              </div>
              <div className="flex justify-end">{renderLightingToggle()}</div>
            </div>
          </m.div>
        </m.div>
      )}
    </AnimatePresence>
  );
};

type Props = {
  isOpen?: boolean;
  toggle: () => void;
  navbarSizeClasses: NavbarClasses;
  renderLightingToggle: () => ReactNode;
};
